import React from 'react';
import { Reveal } from '../Reveal';
import { SectionEyebrow } from '../SectionEyebrow';
import { ArrowRightIcon } from 'lucide-react';
import { GlowBorder } from '../GlowBorder';
const before = ['Te sientes disperso.', 'Sientes que te falta dirección.', 'Te cuesta sostener hábitos.', 'Tus emociones te sobrepasan.', 'Tu cuerpo te pide atención.', 'Tu intuición está apagada.', 'Tu propósito se siente borroso.'];
const after = ['Más claridad interior.', 'Más conexión contigo mismo.', 'Más disciplina sin castigarte.', 'Más comprensión emocional.', 'Más conciencia de tu cuerpo.', 'Más confianza en tu intuición.', 'Más sentido de propósito.'];
export const Transformation: React.FC = () => <section className="relative bg-navy-mid py-28 lg:py-44 overflow-hidden" data-id="element-353">
    <div className="absolute inset-0 sacred-grid opacity-15" data-id="element-354" />
    <div className="absolute inset-0 pointer-events-none" style={{
    background: 'radial-gradient(ellipse at 70% 50%, rgba(212,175,122,0.12), transparent 60%)'
  }} data-id="element-355" />

    <div className="relative max-w-6xl mx-auto px-6 lg:px-8" data-id="element-356">
      <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-357">
        <Reveal data-id="element-358">
          <SectionEyebrow data-id="element-359">La promesa</SectionEyebrow>
        </Reveal>
        <Reveal delay={0.1} data-id="element-360">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.1] text-ivory text-balance" style={{
          fontWeight: 300
        }} data-id="element-361">
            Lo que este libro{' '}
            <span className="italic gold-text" style={{
            fontWeight: 400
          }} data-id="element-362">
              puede despertar en ti
            </span>
          </h2>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-[1fr_auto_1fr] gap-8 md:gap-6 items-stretch" data-id="element-363">
        <Reveal data-id="element-364">
          <div className="h-full glass-card rounded-2xl p-8 lg:p-10" data-id="element-365">
            <div className="text-[10px] uppercase tracking-eyebrow text-ivory/40 mb-7" data-id="element-366">
              Antes
            </div>
            <ul className="space-y-4" data-id="element-367">
              {before.map(item => <li key={item} className="flex items-start gap-3 text-ivory/65 font-light leading-relaxed" data-id="element-368">
                  <span className="w-1 h-1 rounded-full bg-ivory/30 mt-2.5 flex-shrink-0" data-id="element-369" />
                  <span data-id="element-370">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>

        <div className="hidden md:flex items-center justify-center" data-id="element-371">
          <div className="w-12 h-12 rounded-full border border-gold/40 flex items-center justify-center bg-navy-deep" style={{
          boxShadow: '0 0 30px rgba(212,175,122,0.3)'
        }} data-id="element-372">
            <ArrowRightIcon className="w-5 h-5 text-gold" strokeWidth={1.5} data-id="element-373" />
          </div>
        </div>

        <Reveal delay={0.1} data-id="element-374">
          <GlowBorder intensity="medium" duration={10} className="h-full" data-id="element-375">
            <div className="h-full rounded-2xl p-8 lg:p-10 relative overflow-hidden" style={{
            background: 'linear-gradient(180deg, rgba(212,175,122,0.14), rgba(212,175,122,0.04))'
          }} data-id="element-376">
              <div className="absolute -top-20 -right-20 w-60 h-60 rounded-full opacity-30 blur-3xl" style={{
              background: 'radial-gradient(circle, rgba(212,175,122,0.6), transparent 70%)'
            }} data-id="element-377" />
              <div className="relative" data-id="element-378">
                <div className="text-[10px] uppercase tracking-eyebrow text-gold mb-7" data-id="element-379">
                  Después
                </div>
                <ul className="space-y-4" data-id="element-380">
                  {after.map(item => <li key={item} className="flex items-start gap-3 text-ivory/85 font-light leading-relaxed" data-id="element-381">
                      <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2.5 flex-shrink-0" style={{
                    boxShadow: '0 0 10px rgba(212,175,122,0.7)'
                  }} data-id="element-382" />
                      <span data-id="element-383">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </GlowBorder>
        </Reveal>
      </div>
    </div>
  </section>;